import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';

import x5GMaps from 'x5-gmaps'; // entire BS Vue package
import LocationsResults from './vue/LocationsResults.vue';

const apiKeyEl = document.getElementById('vue-locations-wrapper');
const gMapsKey = apiKeyEl.getAttribute('data-js-gmaps');

Vue.use(BootstrapVue);

// Vue.config.devtools = true;

Vue.use(x5GMaps, { key: gMapsKey, libraries: ['places'] });

const LocationsResultsEl = document.getElementById('filter-locations-vue');

// locations
if (LocationsResultsEl != null) {
	new Vue({ // eslint-disable-line no-new
		el: '#filter-locations-vue',
		render(h) {
			return h(LocationsResults);
		},
	});
}